import "./Footer.css";
import { useT } from "@/i18n/context";
import { company } from "@/data/company";
import penguinMark from "@/assets/penguin-mark.svg";

export function Footer() {
  const t = useT();
  const ro = company.registeredOffice;
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <img className="footer__mark" src={penguinMark} alt="" aria-hidden="true" />
        <div className="footer__brand">
          <strong>{company.legalName}</strong>
          <span className="footer__status">{t.footer.statusLabel}</span>
        </div>
        <ul className="footer__legal">
          <li>{t.footer.vatLabel}: {company.vat}</li>
          <li>{t.footer.reaLabel}: {company.rea}</li>
          <li>{t.footer.capitalLabel}: {company.shareCapital}</li>
          <li>{t.footer.registeredOfficeLabel}: {ro.street}, {ro.zip} {ro.city} ({ro.province})</li>
          <li>PEC: {company.pec}</li>
          <li>Email: <a href={`mailto:${company.email}`}>{company.email}</a></li>
        </ul>
        <ul className="footer__links">
          <li><a href="/privacy">{t.footer.privacyLabel}</a></li>
          <li><a href="/terms">{t.footer.termsLabel}</a></li>
        </ul>
        <p className="footer__copy">
          © {company.foundedYear} {company.legalName} — {t.footer.rights}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
